import { useEffect, useState } from 'react'
import { pubSubGrid } from '../../state/pubSub'
import { temporaryGridState } from '../../state/state.grid'

export const useGridCenteredIndexAppState = (index, isActive): boolean => {
    const [state, setState] = useState(
        () => isActive && temporaryGridState.centeredIndex === index,
    )

    useEffect(() => {
        if (!isActive) {
            setState(false)
            return
        }

        const callback = (centeredIndex) => {
            setState(centeredIndex === index)
        }

        /*
            For some reason "setState" is needed to ensure that the state is
            correct when switching pages. Somehow the "useState" above seems to
            preserve the previous state prior to switching pages. Seems to be
            NextJS related. This is true for other hooks as well.
        */
        setState(temporaryGridState.centeredIndex === index)

        return pubSubGrid.on(`state::${index}`, callback)
    }, [isActive, index])

    return state
}
